import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ListItemWrapper } from '../../BKJListItem/BKJListItem.styled.js';
import { useBKJTimeInputContext } from './BKJTimeInput.context.js';
import { formatMinutesToHHmmss } from '../../BKJTimeInput/BKJTimeInput.utils.js';
export const BKJTimeInputItem = (props) => {
    const { getItemProps, highlightedIndex, name, onChange, closeMenu, anchorElement, isOptionSelected, } = useBKJTimeInputContext();
    const isCustomItem = props.index === -1;
    const handleCustomItemClick = useCallback(() => {
        if (onChange) {
            onChange({
                target: {
                    name,
                    value: [formatMinutesToHHmmss(props.minutes)],
                    label: props.label,
                },
            });
        }
        closeMenu();
        anchorElement?.blur();
    }, [onChange, name, props.minutes, props.label, closeMenu, anchorElement]);
    const itemProps = props.index !== undefined && !isCustomItem
        ? getItemProps({
            item: props,
            isSelected: isOptionSelected(props),
            index: props.index,
            disabled: !!props.disabled,
            style: props.style,
        })
        : { style: props.style };
    return (_jsx(ListItemWrapper, { ...itemProps, role: "option", variant: "SpaceBetween", isTargeted: isCustomItem || highlightedIndex === props.index, disabled: !!props.disabled, type: "Standard", onClick: isCustomItem ? handleCustomItemClick : itemProps.onClick, children: props.label }));
};
//# sourceMappingURL=BKJTimeInputItem.js.map